export const ContextualWriteOperations = {
    FixSectionOrder: 'fix-sections-order',
    HideComponentOnAdd: 'hide-component-on-add',
    FixFlexOrder: 'fix-flex-order',
    UpdateScrollEffect: 'update-scroll-effect',
    FixAffectedLayout: 'fix-affected-layout',
};
export const ContextualReadOperations = {
    GetEffectiveLayout: 'get-effective-layout',
};
export const WriteIterations = {
    All: 'all',
    AllReverse: 'all-reverse',
    Global: 'global',
    Cascade: 'cascade-for-update',
    CascadeFromTopTillPointer: 'cascade-from-top-till-pointer',
    CascadeToAllAffected: 'cascade-to-all-affected',
    None: 'none',
};
export const ReadIterations = {
    Cascade: 'cascade-for-read',
    SinglePointer: 'single-pointer',
};
//# sourceMappingURL=iterationStrategies.js.map